// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  margin-left: 0;
}

@media (min-width: 768px) {
  .content {
    margin-left: var(--width-sidebar-close);
    min-height: 100vh;
    transition: margin-left 0.35s ease;
  }
  .content.sidebarOpen {
    margin-left: var(--width-sidebar-open);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE;IACE,uCAAA;IACA,iBAAA;IACA,kCAAA;EACF;EAAE;IACE,sCAAA;EAEJ;AACF","sourcesContent":[".content {\n  margin-left: 0;\n}\n\n@media (min-width: 768px) {\n  .content {\n    margin-left: var(--width-sidebar-close);\n    min-height: 100vh;\n    transition: margin-left 0.35s ease;\n    &.sidebarOpen {\n      margin-left: var(--width-sidebar-open);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
